// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, bool, func, string } from 'prop-types'
import { reduxForm } from 'redux-form'
import { pathDatabaseSearchValidate } from 'validators/databaseSearches'
import { SubmitErrors } from 'components/Form'

import {
  OuterImport,
  Search,
} from './components'

import {
  AdvancedSearchWrapper,
  Pagination,
} from '../common'

const {
  asyncValidate,
  validate,
} = pathDatabaseSearchValidate

const Form = props => {
  const {
    change,
    error,
    form,
    hasResults,
    highlightRows,
    highlightedRows,
  } = props

  return (
    <form
      className={'path-database-search-form heading-font'}
      id={form}>
      {
        highlightRows &&
        <OuterImport
          highlightRows={highlightRows}
          highlightedRows={highlightedRows}
          idRoot={form}
          sourceForm={form} />
      }
      <div className={'bg-white'}>
        <SubmitErrors
          error={error}
          idRoot={form}
          sourceForm={form} />
      </div>
      <AdvancedSearchWrapper
        AdvancedSearch={Search}
        change={change}
        hasResults={hasResults}
        highlightRows={highlightRows}
        highlightedRows={highlightedRows}
        idRoot={`${form}-`}
        sourceForm={form} />
      <Pagination
        idRoot={`${form}-`}
        sourceForm={form} />
    </form>
  )
}

Form.propTypes = {
  change: func.isRequired,
  form: string.isRequired,
  handleSubmit: func.isRequired,
  hasResults: bool.isRequired,
  highlightRows: bool,
  highlightedRows: array.isRequired,
  error: string,
}

export default reduxForm({
  asyncBlurFields: [
    'antennaCode',
    'radioCode',
  ],
  asyncValidate,
  validate,
})(Form)
